/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of
 * this project.
 */
import { ContentChildren, Directive } from "@angular/core";
import { DatagridCellRenderer } from "./cell-renderer";
import { DatagridRenderOrganizer } from "./render-organizer";
var DatagridRowRenderer = (function () {
    function DatagridRowRenderer(organizer) {
        var _this = this;
        this.organizer = organizer;
        this.subscription =
            organizer.alignColumns.subscribe(function () { return _this.setWidths(); });
    }
    DatagridRowRenderer.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    DatagridRowRenderer.prototype.setWidths = function () {
        var _this = this;
        if (this.organizer.widths.length !== this.cells.length) {
            return;
        }
        this.cells.forEach(function (cell, index) {
            var width = _this.organizer.widths[index];
            cell.setWidth(width.strict, width.px);
        });
    };
    DatagridRowRenderer.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.cells.changes.subscribe(function () { _this.setWidths(); });
    };
    DatagridRowRenderer.prototype.ngAfterViewInit = function () { this.setWidths(); };
    return DatagridRowRenderer;
}());
export { DatagridRowRenderer };
DatagridRowRenderer.decorators = [
    { type: Directive, args: [{ selector: "clr-dg-row, clr-dg-row-detail" },] },
];
/** @nocollapse */
DatagridRowRenderer.ctorParameters = function () { return [
    { type: DatagridRenderOrganizer, },
]; };
DatagridRowRenderer.propDecorators = {
    'cells': [{ type: ContentChildren, args: [DatagridCellRenderer,] },],
};
//# sourceMappingURL=row-renderer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/render/row-renderer.js
// module id = 294
// module chunks = 4